module.exports = __webpack_public_path__ + "static/media/brush.7af27497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/brush.svg
// module id = 2458
// module chunks = 7